import { ArrowUpRightIcon } from '@heroicons/react/24/solid'
import { Link } from 'react-router-dom'

function NiceLink(props) {
    return (
        props.link == true ? <Link to={props.href} className="inline-flex items-center text-gray-500 hover:text-black dark:hover:text-white mr-3"><ArrowUpRightIcon className="size-3.5 mr-2" /> <span className="hover:underline">{props.text}</span></Link> : <a href={props.href} target="_blank" className="inline-flex items-center text-gray-500 hover:text-black dark:hover:text-white mr-3"><ArrowUpRightIcon className="size-3.5 mr-2" /> <span className="hover:underline">{props.text}</span></a>
    )
}

export default NiceLink